import { Controller } from "stimulus";
import centreInScroller from "./centre_in_scroller";

// Brings the picked chip into view when the row scrolls sideways on a phone.
export default class SeasonChipsController extends Controller {
  connect() {
    const active = this.element.querySelector('[aria-current="true"]');
    if (active) centreInScroller(this.element, active);
  }
}
